export const LOGIN_GET_PASSWORD = "GET_PASSWORD";
export const LOGIN_CREATE_NEW_PASSWORD = "LOGIN_CREATE_NEW_PASSWORD";
export const LOGIN_PROCESS = "LOGIN_PROCESS";
export const LOGIN_ENABLE_TWO_FACTOR = "LOGIN_ENABLE_TWO_FACTOR";
export const LOGIN_VERIFY = "LOGIN_VERIFY";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const USER_TOKEN_TYPE = "USER_TOKEN";
export const IS_VERIFIED_TYPE = "IS_VERIFIED";
export const IS_VERIFIED_AUTH = "IS_VERIFIED_AUTH";
export const REMEMBER_LOGIN = "REMEMBER_LOGIN";
export const REMEMBER_VERIFY = "REMEMBER_VERIFY";
export const IS_SEND_CODE = "IS_SEND_CODE";
export const SESSION_USER = "SESSION_USER";

export const LOGIN_TYPE_GA = 1;
export const LOGIN_TYPE_EMAIL = 2;
